import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { registerAction } from "../Store";
import { useToast } from "@chakra-ui/react";

import {
  Elements,
  useStripe,
  useElements,
  CardElement,
} from "@stripe/react-stripe-js";
import {
  Box,
  Button,
  Card,
  Heading,
  Input,
  FormLabel,
  ButtonGroup,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import LoginConfirmation from "./LoginConfirmation";
import axios from "axios";
import { BASE_URL } from "../../../constants/defaultValues";

const CheckoutForm = ({ nextStep, prevStep, onOpen }) => {
  const toast = useToast();
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const registerData = useSelector((state) => state.register);
  const [city, setCity] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const getNumber = (inputString) => {
    // Use regular expression to find all numbers in the string and join them into one string
    const numbersArray = inputString.match(/\d+/g);
    const allNumbersAsString = numbersArray ? numbersArray.join("") : "";
    return "+1" + allNumbersAsString;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!name) {
      setError("Enter Name");
      return;
    }

    if (!elements) {
      return;
    }
    setIsLoading(true);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: {
        name: name,
        address: {
          city: city,
        },
      },
    });
    if (paymentMethod) {
      console.log(paymentMethod);
      // setIsLoading(false);
    }
    if (error) {
      setIsLoading(false);
      toast({
        position: "top-right",
        title: "Error",
        description: error?.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      console.log("error");
    } else {
      dispatch(registerAction.addCard(paymentMethod));
      const result = await axios.post(`${BASE_URL}/api/auth/registerUser`, {
        first_name: registerData.firstname,
        last_name: registerData.lastname,
        token: paymentMethod?.id,
        email: registerData.email,
        password: registerData.password,
        account_name: registerData.accountname,
        phone:
          registerData.currentnumber.length > 0
            ? getNumber(registerData.currentnumber)
            : registerData.newnumber,
        plan_name: registerData.plan.name,
        CustomerName: registerData.accountname,
        Street: registerData.street,
        City: registerData.city,
        Region: registerData.region,
        IsoCountry: "US",
        PostalCode: registerData.postalcode,
        ContactPhoneNumber:
          registerData.currentnumber.length > 0
            ? registerData.currentnumber
            : registerData.newnumber,
        isHostedNumber: registerData.currentnumber.length > 0 ? true : false,
      });
      // console.log(result)
      if (result?.data?.error == "false") {
        setIsLoading(false);
        onOpen();
        // setIsProcessing(false);
      } else {
        toast({
          position: "top-right",
          title: "Error",
          description: result?.data?.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setIsLoading(false);
        // setIsProcessing(false);
      }
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <FormLabel>Name</FormLabel>
        <Box mb="10px">
          <Input
            onFocus={() => {
              setError("");
            }}
            placeholder="Enter the name on your card"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div
            style={{
              color: "red",
            }}
          >
            {error.length > 0 && error}
          </div>
        </Box>
        <FormLabel mb="10px">Card</FormLabel>
        <CardElement />
        <ButtonGroup display="flex" gap="20px">
          <Button mt="30px" w="100%" colorScheme="blue" onClick={prevStep}>
            Previous
          </Button>

          <Button
            isLoading={isLoading}
            mt="30px"
            colorScheme="blue"
            w="100%"
            type="submit"
            disabled={!stripe || !elements}
          >
            Confirm
          </Button>
        </ButtonGroup>
      </form>
    </>
  );
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const LoginForm4 = ({ nextStep, prevStep }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const registerData = useSelector((state) => state.register);
  const navigate = useNavigate();
  return (
    <Box mt="10px">
      <LoginConfirmation />
      <Box
        display="flex"
        flexDir="column"
        justifyContent="center"
        alignItems="center"
      >
        {/* <Box p="20px" mb="15px">
          <Heading textAlign="center">Payment Method</Heading>
        </Box> */}

        <Card mt="10px" p="20px" w={{ base: "90%", md: "70%", lg: "60%" }}>
          <Text color="gray.500">
            We'll need your billing info to start your trial - your card
            information is securely stored by Stripe. We won't charge you
            anything unless you decide to continue after your trial is over.
          </Text>
          <Elements stripe={stripePromise}>
            <CheckoutForm
              onOpen={onOpen}
              nextStep={nextStep}
              prevStep={prevStep}
            />
          </Elements>
        </Card>
        <Modal
          size="lg"
          closeOnEsc={false}
          closeOnOverlayClick={false}
          isOpen={isOpen}
          onClose={onClose}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Account Created Succesfully</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>
                {!registerData.currentnumber
                  ? " “Thank you! We’re sending you a confirmation email now. Click the login button below to sign in to your account.”"
                  : <>
                  <p>Thank you!</p>
                  <p>Please check your email for an email with the subject line "Hosted SMS Letter of Authorization (LOA)" and sign this document so that we can successfully host your phone number.</p>
                  <p>The hosting process typically takes no more than a few hours, we'll send you an email as soon as your account is ready to use.</p>
                  
                  </>}
                  
                  
              </Text>
            </ModalBody>
            <ModalFooter>
              <Button
                variant="ghost"
                colorScheme="blue"
                mr={3}
                onClick={() => {
                  onClose();
                  navigate("/login");
                }}
              >
                Close
              </Button>
              <Button
                variant="solid"
                colorScheme="blue"
                onClick={() => navigate("/login")}
              >
                Login
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </Box>
  );
};

export default LoginForm4;
